import axios from 'axios'

let isProduction = process.env.NODE_ENV === 'production'
let urlApi = ''

if (!isProduction) {
  // urlApi = 'https://screens.devsigners.io/api/v1'
  urlApi = 'https://api.bpx.social/api/v2'
} else {
  // urlApi = 'https://screens.devsigners.io/api/v1'
  urlApi = 'https://api.bpx.social/api/v2'
}

// let token = document.head.querySelector('meta[name="csrf-token"]');

export default axios.create({
  baseURL: urlApi,
  headers: {
    common: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  },
  responseType: 'json'
})
